import { useMemo } from 'react'

import { useAccount } from 'wagmi'

import { useBalances } from 'hooks/wallet'
import { useAirdropState } from 'hooks/airdrop'
import { useNativeCurrency } from 'hooks/token'

import { useAirdropParams, useToken } from 'state/airdrop/hooks'

import { isEther } from 'utils/crypto'
import { errors } from 'constants/errors'

import { BalanceErrorWrap, BalanceErrorTitle, BalanceErrorText } from './Style'

export function BalanceError() {
  const token = useToken()
  const { address } = useAccount()

  const balances = useBalances(address)
  const nativeCurr = useNativeCurrency()

  const airdropState = useAirdropState()
  const airdropParams = useAirdropParams()

  const notEther = useMemo(() => token?.address && !isEther(token.address), [token?.address])

  const isInsufficientBalance = useMemo(() => !airdropState.isBalanceEnough, [airdropState.isBalanceEnough])

  const isInsufficientTokenBalance = useMemo(
    () => !airdropState.isTokensBalanceEnough,
    [airdropState.isTokensBalanceEnough],
  )

  return (
    <>
      {notEther && isInsufficientTokenBalance && (
        <BalanceErrorWrap>
          <BalanceErrorTitle>{errors.validation.INSUFFICIENT_FUNDS}</BalanceErrorTitle>
          <BalanceErrorText>
            _wallet-balance: {balances.tokenBalanceToDisplay} {airdropParams.token?.symbol}
          </BalanceErrorText>
          <BalanceErrorText>
            _required: {airdropState.totalTokensToDisplay} {airdropParams.token?.symbol}
          </BalanceErrorText>
        </BalanceErrorWrap>
      )}

      {isInsufficientBalance && (
        <BalanceErrorWrap>
          <BalanceErrorTitle>{errors.validation.INSUFFICIENT_FUNDS}</BalanceErrorTitle>
          <BalanceErrorText>
            _wallet-eth-balance: {balances.nativeBalanceToDisplay} {nativeCurr.symbol}
          </BalanceErrorText>
          <BalanceErrorText>
            _required: {airdropState.approximateCostToDisplay} {nativeCurr.symbol}
          </BalanceErrorText>
        </BalanceErrorWrap>
      )}
    </>
  )
}
